// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import md5 from 'js-md5';  // 使用md5加密登陆密码
import '@/assets/css/default-theme/element-ui/index.css'
// 自定义element-ui图标
import '@/assets/css/default-theme/icon/iconfont.css'
import '@/assets/css/default-theme/animation/animate.min.css'
import '@/assets/css/page/main.css'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$http = axios;
Vue.prototype.$md5 = md5;

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  if(response.data.status && response.data.status == 'NotLogin'){
    store.dispatch('setSystemInfo',null);
    router.push({path:'/'});
  }else{
    return response;
  }

}, function (error) {
  console.log('error: ', error);
  return Promise.reject(error);
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  console.log(to.path,'path')
  let session = sessionStorage.getItem('session');//这里就是权限控制的方法，路由跳转的时候需要去本地获取KEY，不然就直接跳转到了登陆页面
  console.log(session,'ses')
  if (to.path == '/singleLogin/') {
    console.log("singleLogin")
  next()
  }else if(to.path =="/RedirectPage"){
    console.log("定向redirect")
    next()
    }
  else if(!session && to.path !== '/login' ){
    console.log("定向到login")
     next('/login');
  } else if(navigator.userAgent.indexOf('MSIE') > -1){// 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    Vue.prototype.$alert('请使用IE10及以上浏览器查看', '浏览器兼容通知', {
      confirmButtonText: '确定'
    });
    console.log(333)
  }else {
    console.log(111)
    next();
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js